/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */

import React from 'react';
import { View, Image, Text, TouchableOpacity, Platform } from 'react-native';
import styles from '../Updatedscreen/styles/style';
import style from '../Updatedscreen/styles/style.js';
import { getResponsiveStyle, widthInPercentage } from '../../utils/appUtils';
import {
  ALL_CONSTANTS,
} from '../../constants/displayConstants';

const homeButtons = (props) => {
  const {
    measure,
    payamountPage,
    TermsNdConditionpage,
    overDueScreen,
    verification
  } = props;
  const navigateHomescreen = async () => {
    if (Platform.OS == 'web') {
      const pathName = window.location.pathname;
      const domainName = window.location.origin;
      const path = [
        ALL_CONSTANTS.PROFILE_PATH,
        ALL_CONSTANTS.ACCOUNT_PATH,
        ALL_CONSTANTS.CREDIT_CARD_PATH,
        ALL_CONSTANTS.LOAN_PATH,
        ALL_CONSTANTS.DEPOSITS_PATH,
        ALL_CONSTANTS.INVESTMENT_PRODUCT_PATH,
        ALL_CONSTANTS.FOREX_PATH,
        ALL_CONSTANTS.DUE_PATH,
        ALL_CONSTANTS.ATMDEBIT_PATH,
        ALL_CONSTANTS.OTHERURL_PATH
      ];

      let updatedPath = pathName.substr(0, pathName.lastIndexOf('/'));
      if (path.includes(updatedPath)) {
        window.location.href = `${domainName}${updatedPath}`;
        return;
      } else {
        window.location.href = `${domainName}/servicing/index.html`;
      }
    } else {
      window.location.href = `${domainName}/servicing/index.html`;
      //props.navigation.navigate('HomePage');
    }
  };
  return (

    <View >

      <View
        style={(measure === 'LDPI' || measure === 'MDPI' || measure === 'HDPI') &&
          (payamountPage) ?
          [style.HomebuttonsViewMob]
          : [style.HomebuttonsView,
          style[getResponsiveStyle('HomebuttonsView', measure)]]}
      // style={[
      //   style.HomebuttonsView,
      //   style[getResponsiveStyle('HomebuttonsView', measure)]
      // ]}

      >

        <TouchableOpacity
          onPress={() => navigateHomescreen()}
          // style={[
          //   style.HomebuttonsNew,
          //   { backgroundColor: "#e77817", height: payamountPage || TermsNdConditionpage ? measure === 'LDPI' || measure === 'MDPI' || measure === 'HDPI' ? 35 : null : null },
          //   style[getResponsiveStyle('HomebuttonsNew', measure)]
          // ]}
          style={(measure === 'LDPI' || measure === 'MDPI' || measure === 'HDPI') &&
            (payamountPage) ?
            [style.HomebuttonsNewMob]
            : [style.HomebuttonsNew,
            {
              backgroundColor: '#e77817',
              // height: payamountPage || TermsNdConditionpage || overDueScreen? 
              // measure === 'LDPI' || measure === 'MDPI' || measure === 'HDPI' ? 35 : null : null,
              alignItems: 'center',
              paddingVertical: overDueScreen ?
                measure === 'LDPI' ? '35%' : measure === 'MDPI' || measure === 'HDPI' ? '19%' : '5%'
                : measure === 'LDPI' ? '10%' : measure === 'MDPI' || measure === 'HDPI' ? '9%' : '5%'
            },
            style[getResponsiveStyle('HomebuttonsNew', measure)]]}
        >
          <Image
            style={(measure === 'LDPI' || measure === 'MDPI' || measure === 'HDPI') &&
              (payamountPage) ?
              [style.backhomestyleMob]
              : [styles.backhomestyle,
              styles[getResponsiveStyle('backhomestyle', measure)]]}
            // style={[
            //   styles.backhomestyle,
            //   styles[getResponsiveStyle('backhomestyle', measure)]
            // ]}
            source={require('../../assets/images/backHome.png')}
          />
        </TouchableOpacity>
      </View>
    </View>
  );
};

export default homeButtons;
